// Centralized Google Maps configuration
export const GOOGLE_MAPS_CONFIG = {
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
  libraries: ["places", "geometry"], // Include both libraries that are needed
  version: "weekly",
  language: "en",
  region: "US"
};
